// extracted by mini-css-extract-plugin
export default {"container":"popup-page_container__YyFNw"};